import { useSelector } from 'react-redux'

import useReduxAction from '@hooks/useReduxAction'

const useServiceJobChecklistItemTypes = (options = {}) => {
  const { performHttpRequests } = options || {}

  const entities = useSelector(reduxState => reduxState.entities)
  const { serviceJobChecklistItemTypes } = entities

  useReduxAction('serviceJobChecklistItemTypes', 'loadserviceJobChecklistItemTypes', {}, [performHttpRequests], {
    shouldPerformFn: (entityReducer) => {
      const { errors, loaded, loading } = entityReducer
      return performHttpRequests && !loaded && !loading && !errors.length
    },
  })

  return {
    serviceJobChecklistItemTypes,
  }
}

export default useServiceJobChecklistItemTypes
